const decodeBase64 = data => JSON.parse(decodeURIComponent(atob(data)));
const encodeBase64 = value => btoa(value);
const encodeBase64Json = value => btoa(encodeURIComponent(JSON.stringify(value)));

export {
  decodeBase64,
  encodeBase64,
  encodeBase64Json,
};
